import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://linkedin.com/in/kabdulrahmann" className="home__social-icon" target="_blank" rel="noreferrer">
        <i class='uil uil-linkedin'></i>
        </a>
        <a href="https://github.com/kabdulrahmann" className="home__social-icon" target="_blank" rel="noreferrer">
        <i class='uil uil-github-alt'></i>

        </a>
        <a href="https://instagram.com/kabdulrahmann" className="home__social-icon" target="_blank" rel="noreferrer">
        <i class='uil uil-instagram'></i>

        </a>
    </div>
  )
}

export default Social